import { render, staticRenderFns } from "./CardsRodapeBot.vue?vue&type=template&id=405799f0&scoped=true"
import script from "./CardsRodapeBot.vue?vue&type=script&lang=js"
export * from "./CardsRodapeBot.vue?vue&type=script&lang=js"
import style0 from "./CardsRodapeBot.vue?vue&type=style&index=0&id=405799f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405799f0",
  null
  
)

export default component.exports